import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import {
  View,
} from '@uncinc/react-drupal-core';

import Page from '../../../containers/Page';
import useClasses from '../../../hooks/useClasses';

import './style.scss';
import { Main } from '../../../components';

const PageAccountMessages = () => {
  const { t } = useTranslation();
  const { buildClass } = useClasses('PageAccountMessages');

  const currentDomain = useSelector((state) => state.getIn(['uiInternal', 'currentDomain', 'raw'], 'default'));

  const [currentPage, setCurrentPage] = useState(0);

  return (
    <Page className={buildClass()} title={t('pages.account.notifications.title')}>
      <Main className="col-md-8 col-lg-6 offset-md-2 offset-lg-1 py-8 py-lg-12">
        <div className={buildClass('title')}>
          <h1>{t('pages.account.notifications.title')}</h1>
        </div>

        <div className={buildClass('body')}>
          <p>{t(`pages.account.notifications.body.${currentDomain}`)}</p>
        </div>

        <View
          id="message"
          display="block_1"
          page={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </Main>
    </Page>
  );
};

export default PageAccountMessages;
